import { render, staticRenderFns } from "./DashboardPaymentsLists.vue?vue&type=template&id=daf13d34&"
import script from "./DashboardPaymentsLists.vue?vue&type=script&lang=js&"
export * from "./DashboardPaymentsLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports